if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        this.showActiveMedia();
        this.initNavigation();
      }

      initNavigation() {
        if (this._navInit) return;
        this._navInit = true;

        const prev = this.querySelector('.product-media-modal__nav--prev');
        const next = this.querySelector('.product-media-modal__nav--next');
        prev?.addEventListener('click', () => this.navigate(-1));
        next?.addEventListener('click', () => this.navigate(1));

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.navigate(-1);
          if (e.key === 'ArrowRight') this.navigate(1);
        });
      }

      navigate(dir) {
        if (!this.allMedia?.length) return;
        this.currentIndex = (this.currentIndex + dir + this.allMedia.length) % this.allMedia.length;
        this.activateMedia(this.currentIndex);
      }

      showActiveMedia() {
        this.allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const openerId = this.openedBy?.getAttribute('data-media-id');

        let index = 0;
        if (openerId) {
          const found = this.allMedia.findIndex((el) => el.getAttribute('data-media-id') === openerId);
          if (found > -1) index = found;
        }
        this.currentIndex = index;
        this.activateMedia(index);
      }

      activateMedia(index) {
        if (!this.allMedia?.length) return;
        this.allMedia.forEach((el) => el.classList.remove('active'));

        const active = this.allMedia[index];
        if (!active) return;

        active.classList.add('active');
        active.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (active.offsetWidth - container.clientWidth) / 2;

        if (
          active.nodeName === 'DEFERRED-MEDIA' &&
          active.querySelector('template')?.content?.querySelector('.js-youtube')
        ) {
          active.loadContent();
        }

        this.updateNavButtons();
      }

      updateNavButtons() {
        const count = this.allMedia?.length || 0;
        const hide = count <= 1;
        const prev = this.querySelector('.product-media-modal__nav--prev');
        const next = this.querySelector('.product-media-modal__nav--next');
        if (prev) prev.hidden = hide;
        if (next) next.hidden = hide;
      }
    }
  );
}
